import React from 'react';
import PropertiesContent from '@/components/properties/PropertiesContent.tsx';

/**
 * Properties page component — does not require a selected house.
 * Handles empty state internally via PropertiesEmptyState.
 */
const Properties: React.FC = () => {
	return <PropertiesContent />;
};

export const Route = createFileRoute({
	component: Properties,
});
